export default {
	STREAM_POPUP: 'STREAM_POPUP',
	PROFILE_CARD: 'PROFILE_CARD',
	CHAT_MESSAGE_MENU: 'CHAT_MESSAGE_MENU',
	FRIEND_LIST_POPUP: 'FRIEND_LIST_POPUP',
	GAME_FILTER_CONTEXT_MENU: 'GAME_FILTER_CONTEXT_MENU',
	ROOM_MENU: 'ROOM_MENU',
};